var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import { BASE_PATH, BaseAPI } from './base';
export var AuthType;
(function (AuthType) {
    AuthType["IdPassword"] = "ID_PASSWORD";
    AuthType["Sso"] = "SSO";
})(AuthType || (AuthType = {}));
export var ImportUserLogResponseStatusEnum;
(function (ImportUserLogResponseStatusEnum) {
    ImportUserLogResponseStatusEnum["Success"] = "SUCCESS";
    ImportUserLogResponseStatusEnum["Importing"] = "IMPORTING";
    ImportUserLogResponseStatusEnum["ImportError"] = "IMPORT_ERROR";
    ImportUserLogResponseStatusEnum["IllegalError"] = "ILLEGAL_ERROR";
})(ImportUserLogResponseStatusEnum || (ImportUserLogResponseStatusEnum = {}));
export var OrganizationListKind;
(function (OrganizationListKind) {
    OrganizationListKind["None"] = "NONE";
    OrganizationListKind["Clazz"] = "CLAZZ";
    OrganizationListKind["Group"] = "GROUP";
})(OrganizationListKind || (OrganizationListKind = {}));
export var OrganizationSortBy;
(function (OrganizationSortBy) {
    OrganizationSortBy["None"] = "NONE";
    OrganizationSortBy["Order"] = "ORDER";
    OrganizationSortBy["GradeOrder"] = "GRADE_ORDER";
})(OrganizationSortBy || (OrganizationSortBy = {}));
export var OrganizationType;
(function (OrganizationType) {
    OrganizationType["Unspecified"] = "UNSPECIFIED";
    OrganizationType["Clazz"] = "CLAZZ";
    OrganizationType["Group"] = "GROUP";
})(OrganizationType || (OrganizationType = {}));
export var ResponseUserWorkStatusEnum;
(function (ResponseUserWorkStatusEnum) {
    ResponseUserWorkStatusEnum["Updating"] = "UPDATING";
    ResponseUserWorkStatusEnum["Deleting"] = "DELETING";
    ResponseUserWorkStatusEnum["Success"] = "SUCCESS";
    ResponseUserWorkStatusEnum["Failed"] = "FAILED";
})(ResponseUserWorkStatusEnum || (ResponseUserWorkStatusEnum = {}));
export var Role;
(function (Role) {
    Role["AdministratorTeacher"] = "ADMINISTRATOR_TEACHER";
    Role["Teacher"] = "TEACHER";
    Role["Student"] = "STUDENT";
    Role["AdministratorCustomer"] = "ADMINISTRATOR_CUSTOMER";
    Role["Customer"] = "CUSTOMER";
})(Role || (Role = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["Asc"] = "ASC";
    SortOrder["Desc"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var UserAttributesResponseSchoolTypeEnum;
(function (UserAttributesResponseSchoolTypeEnum) {
    UserAttributesResponseSchoolTypeEnum["ElementarySchool"] = "ELEMENTARY_SCHOOL";
    UserAttributesResponseSchoolTypeEnum["MiddleSchool"] = "MIDDLE_SCHOOL";
    UserAttributesResponseSchoolTypeEnum["CompulsoryEducationSchool"] = "COMPULSORY_EDUCATION_SCHOOL";
})(UserAttributesResponseSchoolTypeEnum || (UserAttributesResponseSchoolTypeEnum = {}));
export var UserListKind;
(function (UserListKind) {
    UserListKind["None"] = "NONE";
    UserListKind["Organization"] = "ORGANIZATION";
    UserListKind["Teacher"] = "TEACHER";
    UserListKind["NotSet"] = "NOT_SET";
    UserListKind["School"] = "SCHOOL";
})(UserListKind || (UserListKind = {}));
export var UserSchoolResponseTypeEnum;
(function (UserSchoolResponseTypeEnum) {
    UserSchoolResponseTypeEnum["ElementarySchool"] = "ELEMENTARY_SCHOOL";
    UserSchoolResponseTypeEnum["MiddleSchool"] = "MIDDLE_SCHOOL";
    UserSchoolResponseTypeEnum["CompulsoryEducationSchool"] = "COMPULSORY_EDUCATION_SCHOOL";
})(UserSchoolResponseTypeEnum || (UserSchoolResponseTypeEnum = {}));
export var UserSortBy;
(function (UserSortBy) {
    UserSortBy["None"] = "NONE";
    UserSortBy["Order"] = "ORDER";
    UserSortBy["LoginId"] = "LOGIN_ID";
    UserSortBy["Name"] = "NAME";
    UserSortBy["Ruby"] = "RUBY";
    UserSortBy["Role"] = "ROLE";
    UserSortBy["EnrolledYear"] = "ENROLLED_YEAR";
    UserSortBy["MailAddress"] = "MAIL_ADDRESS";
    UserSortBy["SchoolId"] = "SCHOOL_ID";
    UserSortBy["JoinedSchoolDatetime"] = "JOINED_SCHOOL_DATETIME";
    UserSortBy["Status"] = "STATUS";
})(UserSortBy || (UserSortBy = {}));
export var UserStatus;
(function (UserStatus) {
    UserStatus["Active"] = "ACTIVE";
    UserStatus["Graduate"] = "GRADUATE";
    UserStatus["Delete"] = "DELETE";
})(UserStatus || (UserStatus = {}));
export const ExportUserOrganizationMembershipControllerApiAxiosParamCreator = function (configuration) {
    return {
        getUserClazzMembershipCsvDownloadLink: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/organizations/members/export`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const ExportUserOrganizationMembershipControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ExportUserOrganizationMembershipControllerApiAxiosParamCreator(configuration);
    return {
        getUserClazzMembershipCsvDownloadLink(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserClazzMembershipCsvDownloadLink(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const ExportUserOrganizationMembershipControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ExportUserOrganizationMembershipControllerApiFp(configuration);
    return {
        getUserClazzMembershipCsvDownloadLink(options) {
            return localVarFp.getUserClazzMembershipCsvDownloadLink(options).then((request) => request(axios, basePath));
        },
    };
};
export class ExportUserOrganizationMembershipControllerApi extends BaseAPI {
    getUserClazzMembershipCsvDownloadLink(options) {
        return ExportUserOrganizationMembershipControllerApiFp(this.configuration).getUserClazzMembershipCsvDownloadLink(options).then((request) => request(this.axios, this.basePath));
    }
}
export const FiscalYearControllerApiAxiosParamCreator = function (configuration) {
    return {
        getFiscalYear: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/fiscal-years`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const FiscalYearControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = FiscalYearControllerApiAxiosParamCreator(configuration);
    return {
        getFiscalYear(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getFiscalYear(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const FiscalYearControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FiscalYearControllerApiFp(configuration);
    return {
        getFiscalYear(options) {
            return localVarFp.getFiscalYear(options).then((request) => request(axios, basePath));
        },
    };
};
export class FiscalYearControllerApi extends BaseAPI {
    getFiscalYear(options) {
        return FiscalYearControllerApiFp(this.configuration).getFiscalYear(options).then((request) => request(this.axios, this.basePath));
    }
}
export const ImportUserOrganizationMembershipControllerApiAxiosParamCreator = function (configuration) {
    return {
        importUserClazzMemberships: (file, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('importUserClazzMemberships', 'file', file);
            const localVarPath = `/organizations/members/import`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const ImportUserOrganizationMembershipControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ImportUserOrganizationMembershipControllerApiAxiosParamCreator(configuration);
    return {
        importUserClazzMemberships(file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importUserClazzMemberships(file, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const ImportUserOrganizationMembershipControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ImportUserOrganizationMembershipControllerApiFp(configuration);
    return {
        importUserClazzMemberships(file, options) {
            return localVarFp.importUserClazzMemberships(file, options).then((request) => request(axios, basePath));
        },
    };
};
export class ImportUserOrganizationMembershipControllerApi extends BaseAPI {
    importUserClazzMemberships(file, options) {
        return ImportUserOrganizationMembershipControllerApiFp(this.configuration).importUserClazzMemberships(file, options).then((request) => request(this.axios, this.basePath));
    }
}
export const InternalUserControllerApiAxiosParamCreator = function (configuration) {
    return {
        deleteUsersByIds: (deletionUsersRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('deleteUsersByIds', 'deletionUsersRequest', deletionUsersRequest);
            const localVarPath = `/internal/users/delete`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(deletionUsersRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getUserAttributes: (username, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getUserAttributes', 'username', username);
            const localVarPath = `/internal/users/{username}/attributes`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        linkUser: (userLinkRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('linkUser', 'userLinkRequest', userLinkRequest);
            const localVarPath = `/internal/users/link`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userLinkRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const InternalUserControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = InternalUserControllerApiAxiosParamCreator(configuration);
    return {
        deleteUsersByIds(deletionUsersRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteUsersByIds(deletionUsersRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        getUserAttributes(username, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserAttributes(username, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        linkUser(userLinkRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.linkUser(userLinkRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const InternalUserControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = InternalUserControllerApiFp(configuration);
    return {
        deleteUsersByIds(deletionUsersRequest, options) {
            return localVarFp.deleteUsersByIds(deletionUsersRequest, options).then((request) => request(axios, basePath));
        },
        getUserAttributes(username, options) {
            return localVarFp.getUserAttributes(username, options).then((request) => request(axios, basePath));
        },
        linkUser(userLinkRequest, options) {
            return localVarFp.linkUser(userLinkRequest, options).then((request) => request(axios, basePath));
        },
    };
};
export class InternalUserControllerApi extends BaseAPI {
    deleteUsersByIds(deletionUsersRequest, options) {
        return InternalUserControllerApiFp(this.configuration).deleteUsersByIds(deletionUsersRequest, options).then((request) => request(this.axios, this.basePath));
    }
    getUserAttributes(username, options) {
        return InternalUserControllerApiFp(this.configuration).getUserAttributes(username, options).then((request) => request(this.axios, this.basePath));
    }
    linkUser(userLinkRequest, options) {
        return InternalUserControllerApiFp(this.configuration).linkUser(userLinkRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
export const OrganizationControllerApiAxiosParamCreator = function (configuration) {
    return {
        addOrganization: (postOrganizationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('addOrganization', 'postOrganizationRequest', postOrganizationRequest);
            const localVarPath = `/organizations`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(postOrganizationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        deleteOrganizationById: (organizationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('deleteOrganizationById', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getOrganizationById: (organizationId, userCountRequired, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getOrganizationById', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (userCountRequired !== undefined) {
                localVarQueryParameter['userCountRequired'] = userCountRequired;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getOrganizations: (listKinds, aggregationOnly, sortBy, sortOrder, userCountRequired, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/organizations`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (listKinds) {
                localVarQueryParameter['listKinds'] = listKinds;
            }
            if (aggregationOnly !== undefined) {
                localVarQueryParameter['aggregationOnly'] = aggregationOnly;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (userCountRequired !== undefined) {
                localVarQueryParameter['userCountRequired'] = userCountRequired;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        updateOrganization: (putOrganizationsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('updateOrganization', 'putOrganizationsRequest', putOrganizationsRequest);
            const localVarPath = `/organizations`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(putOrganizationsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        updateOrganization1: (organizationId, putOrganizationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('updateOrganization1', 'organizationId', organizationId);
            assertParamExists('updateOrganization1', 'putOrganizationRequest', putOrganizationRequest);
            const localVarPath = `/organizations/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(putOrganizationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const OrganizationControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrganizationControllerApiAxiosParamCreator(configuration);
    return {
        addOrganization(postOrganizationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addOrganization(postOrganizationRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        deleteOrganizationById(organizationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrganizationById(organizationId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        getOrganizationById(organizationId, userCountRequired, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOrganizationById(organizationId, userCountRequired, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        getOrganizations(listKinds, aggregationOnly, sortBy, sortOrder, userCountRequired, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOrganizations(listKinds, aggregationOnly, sortBy, sortOrder, userCountRequired, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        updateOrganization(putOrganizationsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateOrganization(putOrganizationsRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        updateOrganization1(organizationId, putOrganizationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateOrganization1(organizationId, putOrganizationRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const OrganizationControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrganizationControllerApiFp(configuration);
    return {
        addOrganization(postOrganizationRequest, options) {
            return localVarFp.addOrganization(postOrganizationRequest, options).then((request) => request(axios, basePath));
        },
        deleteOrganizationById(organizationId, options) {
            return localVarFp.deleteOrganizationById(organizationId, options).then((request) => request(axios, basePath));
        },
        getOrganizationById(organizationId, userCountRequired, options) {
            return localVarFp.getOrganizationById(organizationId, userCountRequired, options).then((request) => request(axios, basePath));
        },
        getOrganizations(listKinds, aggregationOnly, sortBy, sortOrder, userCountRequired, options) {
            return localVarFp.getOrganizations(listKinds, aggregationOnly, sortBy, sortOrder, userCountRequired, options).then((request) => request(axios, basePath));
        },
        updateOrganization(putOrganizationsRequest, options) {
            return localVarFp.updateOrganization(putOrganizationsRequest, options).then((request) => request(axios, basePath));
        },
        updateOrganization1(organizationId, putOrganizationRequest, options) {
            return localVarFp.updateOrganization1(organizationId, putOrganizationRequest, options).then((request) => request(axios, basePath));
        },
    };
};
export class OrganizationControllerApi extends BaseAPI {
    addOrganization(postOrganizationRequest, options) {
        return OrganizationControllerApiFp(this.configuration).addOrganization(postOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    deleteOrganizationById(organizationId, options) {
        return OrganizationControllerApiFp(this.configuration).deleteOrganizationById(organizationId, options).then((request) => request(this.axios, this.basePath));
    }
    getOrganizationById(organizationId, userCountRequired, options) {
        return OrganizationControllerApiFp(this.configuration).getOrganizationById(organizationId, userCountRequired, options).then((request) => request(this.axios, this.basePath));
    }
    getOrganizations(listKinds, aggregationOnly, sortBy, sortOrder, userCountRequired, options) {
        return OrganizationControllerApiFp(this.configuration).getOrganizations(listKinds, aggregationOnly, sortBy, sortOrder, userCountRequired, options).then((request) => request(this.axios, this.basePath));
    }
    updateOrganization(putOrganizationsRequest, options) {
        return OrganizationControllerApiFp(this.configuration).updateOrganization(putOrganizationsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    updateOrganization1(organizationId, putOrganizationRequest, options) {
        return OrganizationControllerApiFp(this.configuration).updateOrganization1(organizationId, putOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
export const ProfileControllerApiAxiosParamCreator = function (configuration) {
    return {
        deleteProfileIcon: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/profile/icon`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        uploadProfileIcon: (file, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('uploadProfileIcon', 'file', file);
            const localVarPath = `/users/profile/icon`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const ProfileControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProfileControllerApiAxiosParamCreator(configuration);
    return {
        deleteProfileIcon(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteProfileIcon(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        uploadProfileIcon(file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadProfileIcon(file, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const ProfileControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProfileControllerApiFp(configuration);
    return {
        deleteProfileIcon(options) {
            return localVarFp.deleteProfileIcon(options).then((request) => request(axios, basePath));
        },
        uploadProfileIcon(file, options) {
            return localVarFp.uploadProfileIcon(file, options).then((request) => request(axios, basePath));
        },
    };
};
export class ProfileControllerApi extends BaseAPI {
    deleteProfileIcon(options) {
        return ProfileControllerApiFp(this.configuration).deleteProfileIcon(options).then((request) => request(this.axios, this.basePath));
    }
    uploadProfileIcon(file, options) {
        return ProfileControllerApiFp(this.configuration).uploadProfileIcon(file, options).then((request) => request(this.axios, this.basePath));
    }
}
export const SchoolOptionControllerApiAxiosParamCreator = function (configuration) {
    return {
        getSchoolOption: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/school-options`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        updateSchoolOption: (schoolOptionRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('updateSchoolOption', 'schoolOptionRequest', schoolOptionRequest);
            const localVarPath = `/school-options`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(schoolOptionRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const SchoolOptionControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SchoolOptionControllerApiAxiosParamCreator(configuration);
    return {
        getSchoolOption(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSchoolOption(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        updateSchoolOption(schoolOptionRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateSchoolOption(schoolOptionRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const SchoolOptionControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SchoolOptionControllerApiFp(configuration);
    return {
        getSchoolOption(options) {
            return localVarFp.getSchoolOption(options).then((request) => request(axios, basePath));
        },
        updateSchoolOption(schoolOptionRequest, options) {
            return localVarFp.updateSchoolOption(schoolOptionRequest, options).then((request) => request(axios, basePath));
        },
    };
};
export class SchoolOptionControllerApi extends BaseAPI {
    getSchoolOption(options) {
        return SchoolOptionControllerApiFp(this.configuration).getSchoolOption(options).then((request) => request(this.axios, this.basePath));
    }
    updateSchoolOption(schoolOptionRequest, options) {
        return SchoolOptionControllerApiFp(this.configuration).updateSchoolOption(schoolOptionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
export const UserControllerApiAxiosParamCreator = function (configuration) {
    return {
        addUser: (postUserRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('addUser', 'postUserRequest', postUserRequest);
            const localVarPath = `/users`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(postUserRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        deleteUserById: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('deleteUserById', 'userId', userId);
            const localVarPath = `/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        downloadImportErrorLog: (logId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('downloadImportErrorLog', 'logId', logId);
            const localVarPath = `/users/import/logs/error/{logId}`
                .replace(`{${"logId"}}`, encodeURIComponent(String(logId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        downloadUsersAtCSV: (role, authType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/export`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }
            if (authType !== undefined) {
                localVarQueryParameter['authType'] = authType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getAvailableUsersByIds: (getUsersRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getAvailableUsersByIds', 'getUsersRequest', getUsersRequest);
            const localVarPath = `/users/read/check`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getUsersRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getCurrentUser: (organizationInfo, schoolInfo, previousSchoolInfo, customerInfo, profileIconInfo, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/current`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (organizationInfo !== undefined) {
                localVarQueryParameter['organizationInfo'] = organizationInfo;
            }
            if (schoolInfo !== undefined) {
                localVarQueryParameter['schoolInfo'] = schoolInfo;
            }
            if (previousSchoolInfo !== undefined) {
                localVarQueryParameter['previousSchoolInfo'] = previousSchoolInfo;
            }
            if (customerInfo !== undefined) {
                localVarQueryParameter['customerInfo'] = customerInfo;
            }
            if (profileIconInfo !== undefined) {
                localVarQueryParameter['profileIconInfo'] = profileIconInfo;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getImportLogs: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/import/logs`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getUsers: (organizationInfo, ordinal, listKind, role, organizationId, schoolId, query, enrolledYearStart, enrolledYearEnd, authType, status, sortBy, sortOrder, limit, offset, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (organizationInfo !== undefined) {
                localVarQueryParameter['organizationInfo'] = organizationInfo;
            }
            if (ordinal !== undefined) {
                localVarQueryParameter['ordinal'] = ordinal;
            }
            if (listKind !== undefined) {
                localVarQueryParameter['listKind'] = listKind;
            }
            if (role) {
                localVarQueryParameter['role'] = role;
            }
            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }
            if (schoolId !== undefined) {
                localVarQueryParameter['schoolId'] = schoolId;
            }
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (enrolledYearStart !== undefined) {
                localVarQueryParameter['enrolledYearStart'] = enrolledYearStart;
            }
            if (enrolledYearEnd !== undefined) {
                localVarQueryParameter['enrolledYearEnd'] = enrolledYearEnd;
            }
            if (authType !== undefined) {
                localVarQueryParameter['authType'] = authType;
            }
            if (status) {
                localVarQueryParameter['status'] = status;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getUsersByIds: (getUsersRequest, organizationInfo, ordinal, schoolInfo, previousSchoolInfo, skipNotFoundUser, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getUsersByIds', 'getUsersRequest', getUsersRequest);
            const localVarPath = `/users/read`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (organizationInfo !== undefined) {
                localVarQueryParameter['organizationInfo'] = organizationInfo;
            }
            if (ordinal !== undefined) {
                localVarQueryParameter['ordinal'] = ordinal;
            }
            if (schoolInfo !== undefined) {
                localVarQueryParameter['schoolInfo'] = schoolInfo;
            }
            if (previousSchoolInfo !== undefined) {
                localVarQueryParameter['previousSchoolInfo'] = previousSchoolInfo;
            }
            if (skipNotFoundUser !== undefined) {
                localVarQueryParameter['skipNotFoundUser'] = skipNotFoundUser;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getUsersRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        importUsers: (role, file, ssoEnable, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('importUsers', 'role', role);
            assertParamExists('importUsers', 'file', file);
            const localVarPath = `/users/import`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }
            if (ssoEnable !== undefined) {
                localVarQueryParameter['ssoEnable'] = ssoEnable;
            }
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        resetPasswordById: (resetPasswordRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('resetPasswordById', 'resetPasswordRequest', resetPasswordRequest);
            const localVarPath = `/users/password`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        updateUser: (putUserRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('updateUser', 'putUserRequest', putUserRequest);
            const localVarPath = `/users`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(putUserRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const UserControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = UserControllerApiAxiosParamCreator(configuration);
    return {
        addUser(postUserRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addUser(postUserRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        deleteUserById(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteUserById(userId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        downloadImportErrorLog(logId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadImportErrorLog(logId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        downloadUsersAtCSV(role, authType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadUsersAtCSV(role, authType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        getAvailableUsersByIds(getUsersRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAvailableUsersByIds(getUsersRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        getCurrentUser(organizationInfo, schoolInfo, previousSchoolInfo, customerInfo, profileIconInfo, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCurrentUser(organizationInfo, schoolInfo, previousSchoolInfo, customerInfo, profileIconInfo, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        getImportLogs(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getImportLogs(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        getUsers(organizationInfo, ordinal, listKind, role, organizationId, schoolId, query, enrolledYearStart, enrolledYearEnd, authType, status, sortBy, sortOrder, limit, offset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUsers(organizationInfo, ordinal, listKind, role, organizationId, schoolId, query, enrolledYearStart, enrolledYearEnd, authType, status, sortBy, sortOrder, limit, offset, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        getUsersByIds(getUsersRequest, organizationInfo, ordinal, schoolInfo, previousSchoolInfo, skipNotFoundUser, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUsersByIds(getUsersRequest, organizationInfo, ordinal, schoolInfo, previousSchoolInfo, skipNotFoundUser, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        importUsers(role, file, ssoEnable, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importUsers(role, file, ssoEnable, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        resetPasswordById(resetPasswordRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resetPasswordById(resetPasswordRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        updateUser(putUserRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateUser(putUserRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const UserControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UserControllerApiFp(configuration);
    return {
        addUser(postUserRequest, options) {
            return localVarFp.addUser(postUserRequest, options).then((request) => request(axios, basePath));
        },
        deleteUserById(userId, options) {
            return localVarFp.deleteUserById(userId, options).then((request) => request(axios, basePath));
        },
        downloadImportErrorLog(logId, options) {
            return localVarFp.downloadImportErrorLog(logId, options).then((request) => request(axios, basePath));
        },
        downloadUsersAtCSV(role, authType, options) {
            return localVarFp.downloadUsersAtCSV(role, authType, options).then((request) => request(axios, basePath));
        },
        getAvailableUsersByIds(getUsersRequest, options) {
            return localVarFp.getAvailableUsersByIds(getUsersRequest, options).then((request) => request(axios, basePath));
        },
        getCurrentUser(organizationInfo, schoolInfo, previousSchoolInfo, customerInfo, profileIconInfo, options) {
            return localVarFp.getCurrentUser(organizationInfo, schoolInfo, previousSchoolInfo, customerInfo, profileIconInfo, options).then((request) => request(axios, basePath));
        },
        getImportLogs(options) {
            return localVarFp.getImportLogs(options).then((request) => request(axios, basePath));
        },
        getUsers(organizationInfo, ordinal, listKind, role, organizationId, schoolId, query, enrolledYearStart, enrolledYearEnd, authType, status, sortBy, sortOrder, limit, offset, options) {
            return localVarFp.getUsers(organizationInfo, ordinal, listKind, role, organizationId, schoolId, query, enrolledYearStart, enrolledYearEnd, authType, status, sortBy, sortOrder, limit, offset, options).then((request) => request(axios, basePath));
        },
        getUsersByIds(getUsersRequest, organizationInfo, ordinal, schoolInfo, previousSchoolInfo, skipNotFoundUser, options) {
            return localVarFp.getUsersByIds(getUsersRequest, organizationInfo, ordinal, schoolInfo, previousSchoolInfo, skipNotFoundUser, options).then((request) => request(axios, basePath));
        },
        importUsers(role, file, ssoEnable, options) {
            return localVarFp.importUsers(role, file, ssoEnable, options).then((request) => request(axios, basePath));
        },
        resetPasswordById(resetPasswordRequest, options) {
            return localVarFp.resetPasswordById(resetPasswordRequest, options).then((request) => request(axios, basePath));
        },
        updateUser(putUserRequest, options) {
            return localVarFp.updateUser(putUserRequest, options).then((request) => request(axios, basePath));
        },
    };
};
export class UserControllerApi extends BaseAPI {
    addUser(postUserRequest, options) {
        return UserControllerApiFp(this.configuration).addUser(postUserRequest, options).then((request) => request(this.axios, this.basePath));
    }
    deleteUserById(userId, options) {
        return UserControllerApiFp(this.configuration).deleteUserById(userId, options).then((request) => request(this.axios, this.basePath));
    }
    downloadImportErrorLog(logId, options) {
        return UserControllerApiFp(this.configuration).downloadImportErrorLog(logId, options).then((request) => request(this.axios, this.basePath));
    }
    downloadUsersAtCSV(role, authType, options) {
        return UserControllerApiFp(this.configuration).downloadUsersAtCSV(role, authType, options).then((request) => request(this.axios, this.basePath));
    }
    getAvailableUsersByIds(getUsersRequest, options) {
        return UserControllerApiFp(this.configuration).getAvailableUsersByIds(getUsersRequest, options).then((request) => request(this.axios, this.basePath));
    }
    getCurrentUser(organizationInfo, schoolInfo, previousSchoolInfo, customerInfo, profileIconInfo, options) {
        return UserControllerApiFp(this.configuration).getCurrentUser(organizationInfo, schoolInfo, previousSchoolInfo, customerInfo, profileIconInfo, options).then((request) => request(this.axios, this.basePath));
    }
    getImportLogs(options) {
        return UserControllerApiFp(this.configuration).getImportLogs(options).then((request) => request(this.axios, this.basePath));
    }
    getUsers(organizationInfo, ordinal, listKind, role, organizationId, schoolId, query, enrolledYearStart, enrolledYearEnd, authType, status, sortBy, sortOrder, limit, offset, options) {
        return UserControllerApiFp(this.configuration).getUsers(organizationInfo, ordinal, listKind, role, organizationId, schoolId, query, enrolledYearStart, enrolledYearEnd, authType, status, sortBy, sortOrder, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }
    getUsersByIds(getUsersRequest, organizationInfo, ordinal, schoolInfo, previousSchoolInfo, skipNotFoundUser, options) {
        return UserControllerApiFp(this.configuration).getUsersByIds(getUsersRequest, organizationInfo, ordinal, schoolInfo, previousSchoolInfo, skipNotFoundUser, options).then((request) => request(this.axios, this.basePath));
    }
    importUsers(role, file, ssoEnable, options) {
        return UserControllerApiFp(this.configuration).importUsers(role, file, ssoEnable, options).then((request) => request(this.axios, this.basePath));
    }
    resetPasswordById(resetPasswordRequest, options) {
        return UserControllerApiFp(this.configuration).resetPasswordById(resetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }
    updateUser(putUserRequest, options) {
        return UserControllerApiFp(this.configuration).updateUser(putUserRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
export const UserOrganizationMembershipControllerApiAxiosParamCreator = function (configuration) {
    return {
        addUserOrganizationMemberships: (organizationId, userMembershipsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('addUserOrganizationMemberships', 'organizationId', organizationId);
            assertParamExists('addUserOrganizationMemberships', 'userMembershipsRequest', userMembershipsRequest);
            const localVarPath = `/organizations/{organizationId}/members`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userMembershipsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        deleteUserOrganizationMembership: (organizationId, userIdsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('deleteUserOrganizationMembership', 'organizationId', organizationId);
            assertParamExists('deleteUserOrganizationMembership', 'userIdsRequest', userIdsRequest);
            const localVarPath = `/organizations/{organizationId}/members`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userIdsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        updateAllUsersOrganizationMemberships: (organizationType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('updateAllUsersOrganizationMemberships', 'organizationType', organizationType);
            const localVarPath = `/organizations/members`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (organizationType !== undefined) {
                localVarQueryParameter['organizationType'] = organizationType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        updateCurrentUserOrganizationMemberships: (currentUserMembershipsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('updateCurrentUserOrganizationMemberships', 'currentUserMembershipsRequest', currentUserMembershipsRequest);
            const localVarPath = `/organizations/members/current`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(currentUserMembershipsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        updateUserOrganizationMemberships: (organizationId, userMembershipsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('updateUserOrganizationMemberships', 'organizationId', organizationId);
            assertParamExists('updateUserOrganizationMemberships', 'userMembershipsRequest', userMembershipsRequest);
            const localVarPath = `/organizations/{organizationId}/members`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userMembershipsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const UserOrganizationMembershipControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = UserOrganizationMembershipControllerApiAxiosParamCreator(configuration);
    return {
        addUserOrganizationMemberships(organizationId, userMembershipsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addUserOrganizationMemberships(organizationId, userMembershipsRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        deleteUserOrganizationMembership(organizationId, userIdsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteUserOrganizationMembership(organizationId, userIdsRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        updateAllUsersOrganizationMemberships(organizationType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateAllUsersOrganizationMemberships(organizationType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        updateCurrentUserOrganizationMemberships(currentUserMembershipsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCurrentUserOrganizationMemberships(currentUserMembershipsRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        updateUserOrganizationMemberships(organizationId, userMembershipsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateUserOrganizationMemberships(organizationId, userMembershipsRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const UserOrganizationMembershipControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UserOrganizationMembershipControllerApiFp(configuration);
    return {
        addUserOrganizationMemberships(organizationId, userMembershipsRequest, options) {
            return localVarFp.addUserOrganizationMemberships(organizationId, userMembershipsRequest, options).then((request) => request(axios, basePath));
        },
        deleteUserOrganizationMembership(organizationId, userIdsRequest, options) {
            return localVarFp.deleteUserOrganizationMembership(organizationId, userIdsRequest, options).then((request) => request(axios, basePath));
        },
        updateAllUsersOrganizationMemberships(organizationType, options) {
            return localVarFp.updateAllUsersOrganizationMemberships(organizationType, options).then((request) => request(axios, basePath));
        },
        updateCurrentUserOrganizationMemberships(currentUserMembershipsRequest, options) {
            return localVarFp.updateCurrentUserOrganizationMemberships(currentUserMembershipsRequest, options).then((request) => request(axios, basePath));
        },
        updateUserOrganizationMemberships(organizationId, userMembershipsRequest, options) {
            return localVarFp.updateUserOrganizationMemberships(organizationId, userMembershipsRequest, options).then((request) => request(axios, basePath));
        },
    };
};
export class UserOrganizationMembershipControllerApi extends BaseAPI {
    addUserOrganizationMemberships(organizationId, userMembershipsRequest, options) {
        return UserOrganizationMembershipControllerApiFp(this.configuration).addUserOrganizationMemberships(organizationId, userMembershipsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    deleteUserOrganizationMembership(organizationId, userIdsRequest, options) {
        return UserOrganizationMembershipControllerApiFp(this.configuration).deleteUserOrganizationMembership(organizationId, userIdsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    updateAllUsersOrganizationMemberships(organizationType, options) {
        return UserOrganizationMembershipControllerApiFp(this.configuration).updateAllUsersOrganizationMemberships(organizationType, options).then((request) => request(this.axios, this.basePath));
    }
    updateCurrentUserOrganizationMemberships(currentUserMembershipsRequest, options) {
        return UserOrganizationMembershipControllerApiFp(this.configuration).updateCurrentUserOrganizationMemberships(currentUserMembershipsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    updateUserOrganizationMemberships(organizationId, userMembershipsRequest, options) {
        return UserOrganizationMembershipControllerApiFp(this.configuration).updateUserOrganizationMemberships(organizationId, userMembershipsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
//# sourceMappingURL=api.js.map